import { Badge } from '@workos-inc/design-system';
type BadgeProps = Omit<React.ComponentPropsWithoutRef<typeof Badge>, 'lowContrast'>;
type HttpMethodBadgeProps = BadgeProps & {
  method: string;
};
export const HttpMethodBadge: React.FC<HttpMethodBadgeProps> = ({
  method,
  ...props
}) => <Badge color={getBadgeColor(method)} {...props} data-sentry-element="Badge" data-sentry-component="HttpMethodBadge" data-sentry-source-file="http-method-badge.tsx" />;
const getBadgeColor = (endpointType: string) => {
  const badgeColors = {
    DELETE: 'red',
    GET: 'blue',
    PATCH: 'purple',
    POST: 'green',
    PUT: 'yellow'
  } as const;
  if (endpointType in badgeColors) {
    // Introducing lint rule banning type assertions
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return badgeColors[endpointType as keyof typeof badgeColors];
  }
  throw new Error('cURL endpoint type may be "GET", "POST", "PUT", "PATCH", or "DELETE"');
};